import Big from 'big.js';
import { calcPositionBetween } from 'js/utils/big';

/**
 * The page a standard question belongs to. Standard pages own their questions
 * through `position.pageElements`; a capability page's additional questions
 * have no position of their own and return undefined.
 */
export function getElementPage(element) {
  return element?.get('position')?.get('pageElements')?.get('t');
}

/** The highest position among `collectionName`'s entities under `parentId`. */
export function getLastPosition(doc, collectionName, positionKey, parentId) {
  let lastPosition = null;
  doc.getMap(collectionName).forEach((e) => {
    const position = e.get('position')?.get(positionKey);
    if (
      position?.get('t') === parentId &&
      (lastPosition === null || position.get('p') > lastPosition)
    ) {
      lastPosition = position.get('p');
    }
  });

  return lastPosition;
}

export function moveBefore(
  doc,
  collectionName,
  positionKey,
  sourceGuid,
  destinationGuid
) {
  const sourcePosition = doc
    .getMap(collectionName)
    ?.get(sourceGuid)
    ?.get('position')
    ?.get(positionKey);

  const destPosition = doc
    .getMap(collectionName)
    ?.get(destinationGuid)
    ?.get('position')
    ?.get(positionKey);

  if (
    !sourcePosition ||
    !destPosition ||
    !sourcePosition.get('p') ||
    !destPosition.get('p')
  ) {
    console.warn('invalid arguments to moveBefore');
    return;
  }

  //Move the source question to the same set as the destination question
  sourcePosition.set('t', destPosition.get('t'));

  let prevPos = getPreviousPos(
    doc,
    destPosition.get('p'),
    collectionName,
    positionKey,
    destPosition.get('t')
  );

  if (prevPos === null) {
    prevPos = '0';
  }

  //Set the source position before destination but before previous position
  const newPos = calcPositionBetween(Big(prevPos), Big(destPosition.get('p')));
  sourcePosition.set('p', newPos.toString());
}

export function moveAfter(
  doc,
  collectionName,
  positionKey,
  sourceGuid,
  destinationGuid
) {
  const sourcePosition = doc
    .getMap(collectionName)
    ?.get(sourceGuid)
    ?.get('position')
    ?.get(positionKey);

  const destPosition = doc
    .getMap(collectionName)
    ?.get(destinationGuid)
    ?.get('position')
    ?.get(positionKey);

  if (
    !sourcePosition ||
    !destPosition ||
    !sourcePosition.get('p') ||
    !destPosition.get('p')
  ) {
    console.warn('invalid arguments to moveAfter');
    return;
  }

  //Move the source question to the same set as the destination question
  sourcePosition.set('t', destPosition.get('t'));

  let nextPosition = getFollowingPos(
    doc,
    destPosition.get('p'),
    collectionName,
    positionKey,
    destPosition.get('t')
  );

  if (nextPosition === null) {
    nextPosition = '1';
  }

  //Set the source position after destination but before following position
  const newPos = calcPositionBetween(
    Big(destPosition.get('p')),
    Big(nextPosition)
  );
  sourcePosition.set('p', newPos.toString());
}

/** The position directly after `positionNum` under `parentId`, if any. */
export function getFollowingPos(
  doc,
  positionNum,
  collectionName,
  positionKey,
  parentId
) {
  let followingPos = null;
  doc.getMap(collectionName).forEach((e) => {
    const qPosition = e.get('position')?.get(positionKey);
    if (
      qPosition?.get('t') === parentId &&
      qPosition.get('p') > positionNum &&
      (followingPos === null || qPosition.get('p') < followingPos)
    ) {
      followingPos = qPosition.get('p');
    }
  });

  return followingPos;
}

function getPreviousPos(
  doc,
  positionNum,
  collectionName,
  positionKey,
  parentId
) {
  let previousPos = null;
  doc.getMap(collectionName).forEach((q) => {
    const qPosition = q.get('position')?.get(positionKey);
    if (
      qPosition?.get('t') === parentId &&
      qPosition.get('p') < positionNum &&
      (previousPos === null || qPosition.get('p') > previousPos)
    ) {
      previousPos = qPosition.get('p');
    }
  });

  return previousPos;
}
